import { Component, OnInit } from '@angular/core';
import { MetaService } from 'services/meta.service';

@Component({
	selector: 'ras-careers-page',
	templateUrl: './careers-page.component.html',
	styleUrls: ['./careers-page.component.sass']
})
export class CareersPageComponent implements OnInit {

	constructor(private metaService: MetaService) { }

	ngOnInit() {
		this.metaService.apply('careers')
	}

}
